import { gql } from '@apollo/client';

export const CustodianProfileBaseFields = gql`
  fragment CustodianProfileBaseFields on CustodianProfile {
    id
    name
    status
    company {
      id
      companyWebsite
    }
    custodianTermination {
      id
      status
    }
    custodianAssets {
      id
    }
    custodianIntegrations {
      id
    }
    custodianOperations {
      id
    }
    policy {
      remove
    }
    createdAt
    updatedAt
    activatedAt
  }
`;
